// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"291":"cbffec1f","679":"10bf6874"}[chunkId] + ".chunk.css";
};